<h2 mat-dialog-title>Edit Attributes</h2>
<mat-dialog-content class="dialog-content">
  <table class="attributes-table">
    <tr *ngFor="let attr of newAttributes">
      <td>
        <input
          class="attribute-input"
          [(ngModel)]="attr.key"
          [readonly]="!attr.isNew"
          placeholder="Attribute Key"
        />
      </td>
      <td>
        <input
          class="attribute-input"
          [(ngModel)]="attr.value"
          placeholder="Attribute Value"
        />
      </td>
      <td>
        <button mat-icon-button color="warn" (click)="removeAttribute(attr.key)">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </tr>
  </table>

  <button mat-stroked-button color="primary" (click)="addAttribute()">
    <mat-icon>add</mat-icon> Add Attribute
  </button>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-raised-button color="primary" (click)="save()">Save</button>
</mat-dialog-actions>
